<gs-ratios-bar [currentLang]="translationService.currentLang" [currencyCompany]="productData.currencyCompany" [values]= "ratiosValues"></gs-ratios-bar>
<dx-data-grid #grid (editorComponentClosed)="editorComponentClosed()" [glamResource]="productStandardCostsRes!" class="flex-1"
  [createComponent]="createProductCostComponent">

  <dxi-column dataField="date" dataType="date" [caption]="'common.date' | translate | ucfirst" sortOrder="desc" sortIndex="0">
    <dxi-validation-rule type="required" />
  </dxi-column>

  <dxi-column cellTemplate="productStandardCost" dataField="cost" dataType="number" [caption]="'entity.standardCost' | translate | ucfirst">
    <div *dxTemplate="let item of 'productStandardCost'">
      {{ getFormattedPriceInCompanyCurrency(item.data.cost) }}
    </div>
    <dxi-validation-rule type="required" />
  </dxi-column>

  <dxi-column cellTemplate="stockCostTpl" [allowEditing]="false" dataField="stockCost" dataType="number" [caption]="'entity.product.stockCost' | translate | ucfirst">
    <div *dxTemplate="let item of 'stockCostTpl'">
      {{ getFormattedPriceInCompanyCurrency(item.data.stockCost)}}
    </div>
  </dxi-column>

</dx-data-grid>